<template>
  <div>
    <div class="modal is-modal-large" :class="{'is-active': active}">
      <div class="modal-background" @click.prevent.stop="close"></div>
      <div class="modal-card">
        <div class="row-width-actions-bar">
          <div class="columns is-gapless is-vcentered is-border-bottom">
            <div class="column is-padding-left">
              <div class="has-text-dark is-size-6 is-uppercase">
                <span class="has-text-weight-medium">{{params.title || 'Documents'}}</span>
              </div>
            </div>
            <div class="column is-narrow is-border-left">
              <a class="page-header-btn is-small is-square" @click="close">
                <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
              </a>
            </div>
          </div>
        </div>
        <section class="modal-card-body is-clipped">
          <div class="columns is-gapless is-clipped is-max-height-full">
            <div class="column is-12 is-border-right is-overflow-auto">
              <form @submit.prevent.stop="submit()" id="form-user">
                <div class="columns is-multiline is-border-top is-padding-bottom">
                  <div class="column is-gapless is-paddingless is-12 columns is-multiline">
                    <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Nom du notaire'" :is-required='false' :value="notaire.name"></r-label>
                      <v-input id="name" name="name" @input="val => notaire.name = val" :model="notaire.name"
                              data-vv-as="Nom du notaire"
                              v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
                      </v-input>
                    </div>
                  </div>
									<div class="column is-gapless is-paddingless is-12 columns is-multiline">
										<div class="column is-6 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Téléphone'" :value="notaire.phone" :is-required='false'></r-label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static is-border is-min-width-0 is-square">
                            <span class="icon"><i class="fas fa-mobile-alt"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded">
                          <v-input id="notairePhone" name="promoteurPhone" @input="val => notaire.phone = val" :model="notaire.phone"
                            v-validate="'required'" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Téléphone" v-mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Email'" :value="notaire.email" :is-required='false'></r-label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static is-border is-min-width-0 is-square">
                            <span class="icon"><i class="fas fa-envelope"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded">
                          <v-input id="email" name="email" @input="val => notaire.email = val" :model="notaire.email" class=""
                              v-validate="'email'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Email">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 is-padding-top">
                      <div class="field">
                        <div class="control">
                          <gmap-input :source="address" :is-required='false' @submit="updateAddress"></gmap-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="formActionsSticky is-bottom">
                  <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
                    <div class="column is-4 is-3-widescreen is-margin-right-small">
                      <a @click="close()" class="button is-light is-uppercase is-fullwidth">
                        <span>Annuler</span>
                      </a>
                    </div>
                    <div class="column is-4 is-3-widescreen is-margin-left-small">
                      <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit">
                        <span>Valider</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'

  export default {
    name: 'NotaireContact',
    data () {
      return {
        open: {},
        notaire: {},
        address: {}
      }
    },
    props: {
      active: {
        type: Boolean,
        required: true
      },
      notaireContact: {
        type: Object,
        required: true
      },
      params: {
        type: Object
      }
    },
    methods: {
      updateAddress ({address, location}) {
        this.$set(this, 'address', address)
        this.notaire.address = this.address
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (this.notaire.address) {
          if (this.notaire.address.city === '' ||
          this.notaire.address.line1 === '' ||
          this.notaire.address.country === '' ||
          this.notaire.address.zip_code === '') this.notaire.address = {}
        }
        if (this.notaire.company_name === '') this.notaire.company_name = null
        if (this.notaire.first_name === '') this.notaire.first_name = null
        if (this.notaire.last_name === '') this.notaire.last_name = null
        if (this.notaire.phone === '') this.notaire.phone = null
        if (this.notaire.email === '') this.notaire.email = null
        this.$emit('submit', this.notaire)
      }
    },
    created () {
      this.notaire = cloneDeep(this.notaireContact)
      if (this.notaire.address) {
        this.address = Object.assign({}, this.notaire.address)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/NotaireContact.vue